import {
  CSW_PRODUCT_CLICK,
  SERP_PRODUCT_DETAIL_CLICK,
  TOP_DEALS_LABEL,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { bindDynamicEventsTracking } from 'shared/experiments/utils/tracking'

export default () => {
  const { isEnabled } = getExperimentOnClient(TOP_DEALS_LABEL)

  if (!isEnabled) return

  void activateExperiment(TOP_DEALS_LABEL)

  bindDynamicEventsTracking([
    {
      parentElementSelector:
        '[data-clientside-hook~="algoliaSearchListContainer"]',
      selector:
        '.o-SearchProductListItem__isTopDeal [data-clientside-hook~="productDetailButton"]',
      trackingEvent: SERP_PRODUCT_DETAIL_CLICK,
    },
    {
      parentElementSelector: '[data-clientside-api-call~="fetchCrossSell"]',
      selector:
        '[data-clientside-hook~="slider__item"] .o-ProductSliderItem__isTopDeal',
      trackingEvent: CSW_PRODUCT_CLICK,
    },
    {
      parentElementSelector: '#layout',
      selector:
        '#h_lastActivity [data-clientside-hook~="slider__item"] .o-ProductSliderItem__isTopDeal',
      trackingEvent: CSW_PRODUCT_CLICK,
    },
  ])
}
